import { AiOutlineCheckCircle } from "react-icons/ai"

export interface ICheckList {
  items: string[]
  className?: string
}

export default function CheckList({ items, className }: ICheckList) {
  return (
    <ul className={"px-0 md:px-8" + " " + className}>
      {items.map((item, i) => (
        <li key={`components/CheckList/${i}`} className="flex">
          <AiOutlineCheckCircle className="h-8 w-8 min-w-[2rem] mr-5 fill-green5" />
          <p className="grow text-xl">{item}</p>
        </li>
      ))}
    </ul>
  )
}
